// extracted by mini-css-extract-plugin
export var errorsContainer = "_rm-1";
export var link = "_rm-0";